export default __webpack_public_path__ + "static/media/stock-photo.a9670c2a.jpg";